<template>
    <searchBody>
        <div class="relative flex flex_wrap align_start table_container">
            <!-- <div class="item" @click="onCreate()">
                <Icon type="md-add" class="plus ce" />
            </div> -->
            <div class="flex align_center justify_center item" v-for="(info,index) in dataList" :key="info.id">
                <div class="text_align_center font_weight name">{{ info.title }}</div>
                <Button class="btn_copy" type="success" shape="circle" icon="ios-copy"  @click="onEdit(info.id, 1)"></Button>
                <Button class="btn_edit" type="primary" shape="circle" icon="ios-create"  @click="onEdit(info.id, 0)"></Button>
                <Button class="btn_delete" type="error" shape="circle" icon="ios-trash"  @click="onDelete(info)"></Button>
            </div>
        </div>
        <div class="relative width_100_percent text_align_right">
            <Page size="small" :total="totalPageNum || 1" :page-size="1" show-elevator @on-change="currentChange" />
        </div>
        <mySpin :loading="ajaxLoading"></mySpin>

        <Modal :closable="false" v-model="showCreate" title="创建模版" width="500" :loading="ajaxLoading">
            <div class="form_item">
                <div class="form_label must_input">模版名称</div>
                <Input class="width_300" v-model.trim="formData.title" :maxlength="30" show-word-limit></Input>
            </div>
            <div class="form_item">
                <div class="form_label must_input">模版状态</div>
                <RadioGroup v-model="formData.status" type="button" button-style="solid">
                    <Radio label="1">开启</Radio>
                    <Radio label="0">关闭</Radio>
                </RadioGroup>
            </div>
            <div class="form_item">
                <div class="form_label must_input">选择分类</div>
                <Select filterable v-model="formData.cid">
                    <Option v-for="info in classList" :value="info.id" :key="info.id">{{ info.title }}</Option>
                </Select>
            </div>
            <div slot="footer" class="relative width_100_percent flex align_center justify_center">
                <Button type="primary" ghost @click="onCancelCreate">取消</Button>
                <Button class="ml_100" type="primary" :loading="ajaxLoading" @click="onConfirmCreate">确定</Button>
            </div>
        </Modal>
    </searchBody>
</template>
<script>
import searchBody from '@/components/searchBody';
import pageMixins from '@/lib/pageMixins';
import { reqCheckClassList, reqCheckTempList, reqDelCheckTemp, reqSaveCheckTemp } from '@/lib/request/auth';

export default {
    name: 'monitorManagerTemplateList',
    mixins: [pageMixins],
    components: {
        searchBody,
    },
    data() {
        return {
            dataList: [],
            showCreate: false,
            formData: {
                cid: null,
                id: null,
                title: null,
                status: '1',
                classType: null,
            },
            classList: [],
        };
    },
    mounted() {
        this.reqClassList();
        this.getList();
    },
    methods: {
        //获取检测分类
        reqClassList() {
            reqCheckClassList({
                pageNums: 1,
                pageSize: 200,
                status: 1,
            }).then(res => {
                this.classList = (res.data || {}).list || [];
            });
        },
        //获取列表数据
        getList() {
            this.showAjaxLoading();
            reqCheckTempList(this.params)
                .then(res => {
                    this.dataInjectDataList(res);
                })
                .finally(() => {
                    this.hideAjaxLoading();
                });
        },
        //创建
        onCreate() {
            this.formData.title = null;
            this.formData.status = '1';
            this.showCreate = true;
        },
        //编辑
        onEdit(id = null, isCopy = 0) {
            this.goUrl('/monitorTemplateEdit', {
                id,
                isCopy,
            });
        },
        //删除
        onDelete(info = {}) {
            let { id, title } = info || {};
            this.confirmDialog(`确认删除${title}吗`).then(isOK => {
                if (isOK == 1) {
                    this.showAjaxLoading();
                    reqDelCheckTemp({ id })
                        .then(res => {
                            this.fadeAlert(res.errmsg);
                            this.getList();
                        })
                        .catch(() => {
                            this.hideAjaxLoading();
                        });
                }
            });
        },
        //取消 添加模版
        onCancelCreate() {
            this.showCreate = false;
        },
        //确认添加模版
        onConfirmCreate() {
            this.showAjaxLoading();
            let { cid, title, status } = this.formData || {};
            if (!hm.isNotEmptyString(title)) {
                this.fadeWarning('请输入模版名称');
                this.hideAjaxLoading();
                return;
            }
            reqSaveCheckTemp({
                cid,
                title,
                status,
            })
                .then(res => {
                    this.onCancelCreate();
                    this.fadeAlert(res.errmsg);
                    this.getList();
                })
                .catch(() => {
                    this.hideAjaxLoading();
                });
        },
    },
};
</script>
<style lang="less" scoped>
.table_container {
    gap: 15px;
    padding-bottom: 20px;

    .plus {
        width: fit-content;
        height: fit-content;
        font-size: 40px;
    }

    .item {
        position: relative;
        width: 256px;
        height: 126px;
        border-radius: 8px;
        // background-color: #f5f7f9;
        background-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
        transition: transform 0.3s;
        cursor: pointer;
        .name {
            width: 150px;
            word-break: break-all;
        }
        &:hover {
            box-shadow: 0 0 10px #a1c4fd;
            transform: scale(1.04);

            .btn_copy,
            .btn_edit,
            .btn_delete {
                opacity: 1;
                transform: translateX(-16px);
            }
        }
        .btn_copy,
        .btn_edit,
        .btn_delete {
            position: absolute;
            bottom: 6px;
            opacity: 0;
            transition: transform 0.3s, opacity 0.3s;
        }
        .btn_copy {
            right: 100px;
        }
        .btn_edit {
            right: 50px;
        }
        .btn_delete {
            right: 0;
        }
    }
}
.form_label {
    width: 100px;
}
</style>
